import Vue from 'vue'
import App from './App.vue'
import Footer from './sections/Footer.vue'
import GoogleMap from './components/GoogleMap.vue'
import VueInstagram from 'vue-instagram'

Vue.use(VueInstagram);

Vue.config.productionTip = false

// main.js
import './scss/main.scss'
import AOS from 'aos'
import 'aos/dist/aos.css'
import smoothScroll from './js/smooth-scroll'

new Vue({
    el: '#app',
    created () {
        AOS.init()    
    },
    mounted () {
        smoothScroll();
    },
    render: h => h(App)
})

new Vue({
    el: '#google-map',
    render: h => h(GoogleMap)
})
    
new Vue({
    el: '#footer',
    render: h => h(Footer)
})
  